__turbopack_context__.v({
  "inline": "OutletCardOutletStatus-module-scss-module__9KKNmG__inline",
  "outletAvailabilityTag": "OutletCardOutletStatus-module-scss-module__9KKNmG__outletAvailabilityTag",
  "outletStatusText": "OutletCardOutletStatus-module-scss-module__9KKNmG__outletStatusText",
  "outletStatusWrapper": "OutletCardOutletStatus-module-scss-module__9KKNmG__outletStatusWrapper",
  "separator": "OutletCardOutletStatus-module-scss-module__9KKNmG__separator",
});
